export const ChatType = Object.freeze({
	user: 'user',
	chat: 'chat',
	open: 'open',
	general: 'general',
	videoconf: 'videoconf',
	announcement: 'announcement',
	call: 'call',
	support24Notifier: 'support24Notifier',
	support24Question: 'support24Question',
	crm: 'crm',
	sonetGroup: 'sonetGroup',
	calendar: 'calendar',
	tasks: 'tasks',
	taskComments: 'tasksTask',
	thread: 'thread',
	mail: 'mail',
	lines: 'lines',
	copilot: 'copilot',
	channel: 'channel',
	openChannel: 'openChannel',
	generalChannel: 'generalChannel',
	comment: 'comment',
	collab: 'collab',
});
